import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Checkbox, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { TWIconButton } from "apps/web/src/componentLibrary/TWIconButton/TWIconButton";
import React, { useState } from "react";

export const ThemeViewerIconButton = () => {
  const [disabled, setDisabled] = useState(false);
  const [variantChoice, setVariantChoice] = useState("normal");

  const getContainedVariant = () =>
    variantChoice === "normal"
      ? "contained"
      : variantChoice === "success"
      ? "containedSuccess"
      : variantChoice === "informational"
      ? "containedInformational"
      : variantChoice === "warning"
      ? "containedWarning"
      : "containedDestructive";

  const getOutlinedVariant = () =>
    variantChoice === "normal"
      ? "outlined"
      : variantChoice === "success"
      ? "outlinedSuccess"
      : variantChoice === "informational"
      ? "outlinedInformational"
      : variantChoice === "warning"
      ? "outlinedWarning"
      : "outlinedDestructive";

  const getTextVariant = () =>
    variantChoice === "normal"
      ? "text"
      : variantChoice === "success"
      ? "textSuccess"
      : variantChoice === "informational"
      ? "textInformational"
      : variantChoice === "warning"
      ? "textWarning"
      : "textDestructive";

  return (
    <>
      <Typography variant="h2">TWIconButton</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <FormControlLabel control={<Checkbox checked={disabled} onChange={() => setDisabled(!disabled)} />} label="Disabled" />
          <RadioGroup
            row
            value={variantChoice}
            onChange={e => setVariantChoice(e.target.value)}>
            <FormControlLabel
              value="normal"
              control={<Radio />}
              label="Normal" />
            <FormControlLabel
              value="success"
              control={<Radio />}
              label="Success" />
            <FormControlLabel
              value="informational"
              control={<Radio />}
              label="Informational" />
            <FormControlLabel
              value="warning"
              control={<Radio />}
              label="Warning" />
            <FormControlLabel
              value="destructive"
              control={<Radio />}
              label="Destructive" />
          </RadioGroup>
        </Box>
        <Box sx={{ display: "flex", gap: 4 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h3">Contained</Typography>
            <Box sx={{ alignItems: "flex-start", height: "60px", display: "flex", gap: 2 }}>
              <TWIconButton
                icon={<MoreVertIcon />}
                size="large"
                variant={getContainedVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                size="medium"
                variant={getContainedVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                size="small"
                variant={getContainedVariant()}
                disabled={disabled} />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h3">Outlined</Typography>
            <Box sx={{ alignItems: "flex-start", height: "60px", display: "flex", gap: 2 }}>
              <TWIconButton
                icon={<MoreVertIcon />}
                size="large"
                variant={getOutlinedVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                variant={getOutlinedVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                size="small"
                variant={getOutlinedVariant()}
                disabled={disabled} />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h3">Text</Typography>
            <Box sx={{ alignItems: "flex-start", height: "60px", display: "flex", gap: 2 }}>
              <TWIconButton
                icon={<MoreVertIcon />}
                size="large"
                variant={getTextVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                variant={getTextVariant()}
                disabled={disabled} />
              <TWIconButton
                icon={<MoreVertIcon />}
                size="small"
                variant={getTextVariant()}
                disabled={disabled} />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="subtitle1">Button Heights: Large 44, Medium 36, Small 28</Typography>
          <Typography variant="subtitle1">Icon Font Sizes: Large 24, Medium 20, Small 16</Typography>
        </Box>
      </Box>
    </>
  );
};
